import API from '../../../manager/API';
import { dispatch } from '../../hooks';
import slice from './slice';
import { toast } from 'react-toastify';

export const { setTaskStoppageData, setTaskStoppageStatus } = slice.actions;

const taskStoppage = (url: any) => async () => {
  try {
    const response = await API.taskStoppage.taskStoppage(url);
    dispatch(setTaskStoppageData(response.data));
    dispatch(setTaskStoppageStatus(response.status));
    return { response, status: response.status, data: response.data };
  } catch (error: any) {
    if (error.response.status === 422) {
      toast.error(error.response.data.message);
    }
  }
};

export default {
  taskStoppage
};
